export default "__VITE_ASSET__B4CcCNFT__"